module.exports = __webpack_public_path__ + "img/湖北省地质环境综合信息平台.819f8ea8.jpg";